export default [
    {
        path: "/pamera/:str",
        name: "pamera",
        component: () => import("./index"),
        meta: {
            title: "扫码反馈"
        }
    },]